export default __webpack_public_path__ + "static/media/gallery-big-05.9d23e838.jpg";